import { render, staticRenderFns } from "./MainSubheading.vue?vue&type=template&id=2656306a&scoped=true&lang=html&"
import script from "./MainSubheading.vue?vue&type=script&lang=js&"
export * from "./MainSubheading.vue?vue&type=script&lang=js&"
import style0 from "./MainSubheading.vue?vue&type=style&index=0&id=2656306a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656306a",
  null
  
)

export default component.exports